module.exports = __webpack_public_path__ + "static/media/p12.52976062.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/AdvisorsPartnersTeamResources/p12.svg
// module id = 242
// module chunks = 0